// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { FundChartCreatorModule } from './app.module';
bootstrapAppModule(FundChartCreatorModule);
